import template from './index-administration-tab-content.template.html';
import controller from './index-administration-tab-content.controller';

const indexAdministrationTabContentComponent = {
  template,
  controller,
  controllerAs: 'indexAdministrationTabContentCtrl'
};

export default indexAdministrationTabContentComponent;



// WEBPACK FOOTER //
// ./ui/src/components/index-administration-tab-content/index-administration-tab-content.component.js